// Shared mapping from admin-selectable tile_size → tailwind grid spans
// Mobile is always full-width (col-span-2 in a 2-col grid). md+ uses 12-col bento.
export const TILE_SIZE_OPTIONS = [
  { value: "small",   label_mn: "Жижиг",     label_en: "Small",     span: "md:col-span-3", aspect: "1/1" },
  { value: "medium",  label_mn: "Дунд",      label_en: "Medium",    span: "md:col-span-6", aspect: "4/3" },
  { value: "wide",    label_mn: "Өргөн",     label_en: "Wide",      span: "md:col-span-8", aspect: "16/9" },
  { value: "tall",    label_mn: "Өндөр",     label_en: "Tall",      span: "md:col-span-4 md:row-span-2", aspect: "3/4" },
  { value: "feature", label_mn: "Гол",       label_en: "Feature",   span: "md:col-span-7 md:row-span-2", aspect: "4/5" },
  { value: "full",    label_mn: "Бүтэн мөр", label_en: "Full row",  span: "md:col-span-12", aspect: "21/9" },
];

export const TILE_SIZE_MAP = TILE_SIZE_OPTIONS.reduce((acc, o) => {
  acc[o.value] = o;
  return acc;
}, {});

export function tileSpan(tile_size) {
  return (TILE_SIZE_MAP[tile_size] || TILE_SIZE_MAP.medium).span;
}

export const UNIFORM_SPAN = "md:col-span-4"; // 3 per row on desktop in uniform mode
